import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=62119262&scoped=true"
var script = {}
import style0 from "./bottom.vue?vue&type=style&index=0&id=62119262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62119262",
  null
  
)

export default component.exports